import React from "react";
import GlobalStyle from "./styles/global.js";

function App() {
  return (
    <React.StrictMode>
      <GlobalStyle />
      <main className="placeholder-page">
        <section className="placeholder-hero" aria-labelledby="site-title">
          <div className="placeholder-shell">
            <div className="brand-row" aria-label="Sunrunner Tech">
              <span className="brand-mark">SR</span>
              <div>
                <p className="eyebrow">Sunrunner Tech</p>
                <p className="brand-subtitle">Business systems, automation, and technology consulting</p>
              </div>
            </div>

            <div className="hero-grid">
              <div className="hero-copy">
                <p className="status-pill">Site migration complete</p>
                <h1 id="site-title">SunrunnerTech.com is live on Hostinger.</h1>
                <p className="hero-lede">
                  The new site is being prepared. For now, this page confirms the domain, DNS, SSL, and
                  hosting are working correctly.
                </p>
                <div className="hero-actions" aria-label="Contact options">
                  <a className="primary-action" href="mailto:info@sunrunnertech.com">
                    Contact Sunrunner Tech
                  </a>
                  <a className="secondary-action" href="https://sunrunnertech.com">
                    Refresh site
                  </a>
                </div>
              </div>

              <aside className="proof-card" aria-label="Launch checklist">
                <p className="card-label">Current status</p>
                <ul>
                  <li>
                    <span>DNS</span>
                    <strong>Connected</strong>
                  </li>
                  <li>
                    <span>SSL</span>
                    <strong>Active</strong>
                  </li>
                  <li>
                    <span>Hosting</span>
                    <strong>Hostinger</strong>
                  </li>
                  <li>
                    <span>Full site</span>
                    <strong>Coming soon</strong>
                  </li>
                </ul>
              </aside>
            </div>
          </div>
        </section>
      </main>
    </React.StrictMode>
  );
}

export default App;
